<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "InviteRewardConfig",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'inviteRewardConfig:add',
        update: 'inviteRewardConfig:update',
        delete: 'inviteRewardConfig:delete',
        deleteBatch: 'inviteRewardConfig:deleteBatch'
      },
      url: {
        get: '/inviteRewardConfig/listByCondition',
        add: '/inviteRewardConfig/add',
        update: '/inviteRewardConfig/update',
        delete: '/inviteRewardConfig/delete/',
        delete_batch: '/inviteRewardConfig/deleteBatch',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select'
        },
        width: '',
      }, {
        field: 'taskName',
        label: '任务名称',
        show: true,
        width: '',
      }, {
        field: 'inviteNumber',
        label: '邀请人数',
        show: true,
        width: '',
      }, {
        field: 'reward',
        label: '奖励金额',
        show: true,
        width: '',
      }, {
        field: 'firstChargeMoney',
        label: '首充金额',
        show: true,
        width: '',
      },{
        field: 'rechargeTotal',
        label: '累计金额',
        show: true,
        width: '',
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }],
      operate: [],
      formFields: {
        addTitle: '会员邀请配置',
        updateTitle: '修改会员邀请配置',
        model: [{
          field: 'agentId',
          label: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
          placeholder: '请选择',
          rules: [{
            message: '请选择代理', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'taskName',
          label: '任务名称',
          type: 'textarea',
          placeholder: '任务名称',
          rules: [{message: '请输入用户ID', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'inviteNumber',
          label: '邀请人数',
          type: 'textarea',
          placeholder: '邀请人数',
          rules: [{message: '请输入上级ID', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'reward',
          label: '奖励金额',
          type: 'textarea',
          placeholder: '奖励金额',
          rules: [{message: '请输入奖励金额', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'firstChargeMoney',
          label: '首充金额',
          type: 'textarea',
          placeholder: '首充金额',
          rules: [{message: '请输入首充金额', trigger: 'blur', required: true}],
          add: true,
          update: true,
        },{
          field: 'rechargeTotal',
          label: '累计金额',
          type: 'textarea',
          placeholder: '累计金额',
          rules: [{message: '请输入累计金额', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }],
      }
    }
  }
}
</script>

<style scoped>

</style>
